exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".socialShare{padding:0;text-align:center}.socialShare a{font-size:20px;color:#fff;margin-right:20px;transition:all .2s linear}.socialShare a:last-child{margin-right:0}.socialShare a:hover{color:#3ab8e8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d9d1816","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/SocialShare.vue
// module id = 190
// module chunks = 0